import {graphql, compose} from 'react-apollo';
import gql from 'graphql-tag';

import {
  DeleteWindowMutation,
  DeleteWindowMutationConfig,
  SaveWindowMutation,
  SaveWindowMutationConfig,
  ValidateWindowMutation,
  ValidateWindowMutationConfig
} from '../qql-shared/mutations';
import {Window, Meta} from '../qql-shared/fragments';
import WindowForm from '../components/WindowForm';

const WindowSingleQuery = gql`
  query window($_id:String!) {
    window(_id:$_id) {
      ...Window
    }
    allMetas{
      ...Meta
    }
  }
  ${Window}
  ${Meta}
`;

const WindowSingleQueryConfig = {
  options: ({match}) => ({variables: {_id: match.params.id}})
};

export default compose(
  graphql(SaveWindowMutation, SaveWindowMutationConfig),
  graphql(DeleteWindowMutation, DeleteWindowMutationConfig),
  graphql(ValidateWindowMutation, ValidateWindowMutationConfig),
  graphql(WindowSingleQuery, WindowSingleQueryConfig)
)(WindowForm);



// WEBPACK FOOTER //
// ./src/containers/WindowEdit.js